<template>

  <div class="tw-bg-jrGray-60 tw-w-full tw-flex tw-justify-center" @click="clickEvent">

    <loading v-show="loadingPage || loadingRefresh"></loading>

    <div v-if="naoEncomtrado">
      <nao-encontrado :leilaoId="leilaoSemFirebase.id" :cookie="cookie"></nao-encontrado>
    </div>
    <div v-else>

      <transition name="fade">
        <div
          v-show="!loadingPage && !naoEncomtrado"
          class="tw-w-full tw-px-8 md:tw-px-0 md:tw-min-w-[750px] lg:tw-min-w-[1000px] jr:tw-max-w-[1260px] md:tw-py-16 tw-py-8 tw-justify-center tw-grid tw-grid-cols-1 tw-space-y-8 md:tw-space-y-0 md:tw-gap-8 tw-gap-4 tw-font-poppins"
        >
          <modal-poup-sala-de-disputa
            v-if="modalaviso_trt && leilao.id && dadosPopup.leilao_id"
            :modal="modalaviso_trt"
            :leilao="leilao"
            :dados="dadosPopup"
            @fecharModalPopup="fecharPopup"
          />

          <bread-crumb :categorialeilao="leilaoSemFirebase.categorialeilao"
                       :nomeLeilao="leilaoSemFirebase.nm"></bread-crumb>

          <header-disputa
            ref="headerDisputa"
            :dadosLeilao="leilaoSemFirebase"
            :dadosModeradorId="statusModerador"
            :leilaoid="leilaoId"
            :lotes="lotes"
            :liberado="liberado"
          ></header-disputa>
          <mensagem-box
            v-if="mostrarMesagem && ![6, 8].includes(leilaoSemFirebase.statusmontagem_id)"
            :message="message"
            :liberado="liberado"
            :dadosModeradorId="statusModerador"
            :dadosLeilao="leilaoSemFirebase"
            :usuario="usuario"></mensagem-box>
          <mensagem-box-leilao
            v-show="mostrarMesagem"
            :message_informativo="message_informativo"
            :informativo="informativo"></mensagem-box-leilao>
          <!-- Filtros -->
          <filtro ref="filters" v-show="leilaoSemFirebase.statusleilao_id !== 17" :leilao="leilao" :filtros="filtros"
                  :loadfiltro="loadfiltro" :lotes="lotes" :usuario="usuario"></filtro>

          <seguir-leiloeiro
            v-show="leilao && !leilao.bn_fechamentoautomatico && loadingRefresh === false"
            :firstLoadSalaDisputa="firstLoadSalaDisputa"
            :loadingRefresh="false"
            :lote_id_pregao="lote_id_pregao"
            :leilao="leilao"
            :seguir="seguir"
            tela="saladisputa"
            @seguirLeiloeiro="seguirLeiloeiro()">
          </seguir-leiloeiro>

          <span class="texto-apregoamento" v-show="seguir">
            O Leiloeiro está apregoando o bem abaixo nesse momento.
          </span>

          <ul id="grid" class="products-list" v-show="seguir">
            <li>
              <Item
                :leilao="leilao"
                :dados="lote_em_pregao"
                :liberado="liberado"
                :automatico="fechamento"
                :usuarioid="usuario.id"
                :dados-condicao="dados_condicao"
                :statusleilao_id="statusleilao_id"
                :status="leilao.nm_status"
                :exibirvideo="seguir"
                :saladisputa="saladisputa">
              </Item>
            </li>
          </ul>

          <div v-if="leilao.nm_linkyoutube && isMobile" class="tw-flex tw-justify-center">
            <VideoTransmissao :video-link="formataYoutubeLink(leilao.nm_linkyoutube)"/>
          </div>

          <!-- Formatação dos lotes/Atualização -->
          <div class="transmissao-refresh-dados">
            <div v-if="leilao.nm_linkyoutube" class="tw-mr-2 tw-flex tw-items-center tw-bg-white tw-p-2 tw-rounded-md">
              <VideoTransmissao :video-link="formataYoutubeLink(leilao.nm_linkyoutube)"/>
            </div>
            <div class="tw-flex tw-bg-white tw-p-5 tw-rounded-md tw-gap-3 tw-text-gray-500"
                 v-show="leilaoSemFirebase.statusleilao_id !== 17">
              <div class="tw-cursor-pointer" @click="setVisualizacao('card')">
                <i class="icon-cards"
                   :class="visualizacao === 'card' ? 'tw-text-jrBlue-100' : 'hover:tw-text-jrBlue-100'"></i>
              </div>
              <a href @click="refreshPage" title="Atualizar todos os lotes">
                <i
                  class="icon-refresh hover:tw-text-jrBlue-100"></i></a>
            </div>
          </div>

          <div v-if="lotes.length > 0">
            <div v-if="visualizacao === 'card'" v-show="firstLoadSalaDisputa === false && loadingRefresh === false">
              <ul id="grid"
                  class="tw-flex tw-justify-center tw-items-center tw-flex-wrap tw-gap-12 jr:tw-min-w-[1265px]">
                <li v-for="(lote, idx) in visualizaLotes"
                    :key="idx"
                    class="mb:tw-w-[350px] mb1:tw-w-[270px] componente-lote-li"
                    :class="{destaque: destaqueLoteId === lote.lote_id}"
                    :id="'lote-' + lote.lote_id"
                    @click="salvarLoteId(lote.lote_id)"
                >
                  <card
                    :leilao="leilaoSemFirebase"
                    :dados="lote"
                    :liberado="liberado"
                    :automatico="fechamento"
                    :usuarioid="usuario.id"
                    :statusleilao_id="leilaoSemFirebase.statusleilao_id"
                    :intermediarios="intermediarios"
                    :countLances="countLances[idx]"
                    :paramsite_proposta="paramsite_proposta"
                    :dados-condicao="dados_condicao"
                    :destaqueLoteId="destaqueLoteId"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div>Nenhum lote para exibir</div>
          </div>

          <!-- Paginação -->
          <div v-if="totalPages > 1" class="tw-w-full tw-flex tw-justify-center">
            <div class="tw-flex tw-justify-center tw-p-2 tw-w-fit tw-bg-white tw-rounded tw-gap-4">

              <!-- Ir para a primeira página -->
              <button
                @click="trocarPagina(1)"
                :disabled="currentPage === 1"
                class="tw-flex tw-justify-center tw-items-center tw-p-2 tw-bg-jrGray-100 tw-rounded"
              >
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
              </button>

              <!-- Página anterior -->
              <button
                @click="trocarPagina(currentPage - 1)"
                :disabled="currentPage === 1"
                class="tw-flex tw-justify-center tw-items-center tw-p-2 tw-bg-jrGray-100 tw-rounded"
              >
                <i class="icon-arrow-prev"></i>
              </button>

              <!-- Páginas dinâmicas -->
              <button
                v-for="page in paginatedPages"
                :key="page"
                @click="trocarPagina(page)"
                :class="['tw-px-3 tw-py-1 tw-rounded-md', currentPage === page ? 'tw-bg-jrBlue-200 hover:tw-bg-jrBlue-50 tw-text-white' : 'tw-border-1 hover:tw-bg-gray-50']"
              >
                {{ page }}
              </button>

              <!-- Próxima página -->
              <button
                @click="trocarPagina(currentPage + 1)"
                :disabled="currentPage === totalPages"
                class="tw-flex tw-justify-center tw-items-center tw-p-2 tw-bg-jrGray-100 tw-rounded"
              >
                <i class="icon-arrow-next"></i>
              </button>

              <!-- Ir para a última página -->
              <button
                @click="trocarPagina(totalPages)"
                :disabled="currentPage === totalPages"
                class="tw-flex tw-justify-center tw-items-center tw-p-2 tw-bg-jrGray-100 tw-rounded"
              >
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <ModalHAbilitacaoExtra ref="modalHabilitacao" :info="info"/>
    <CondicoesVenda ref="modalCondicoes" :leilao="leilaoSemFirebase"/>
    <!-- Id leilaoSemFirebase.id referente ao alerta no v-show no modalalertas -->
    <ModalAlertas ref="modalAlertas" v-show="leilaoSemFirebase.id == 10198"/>

  </div>
</template>

<script>
// PLUGIN COMPONENTS
import Paginate from "vuejs-paginate";
import {Stretch} from "vue-loading-spinner";
import {Carousel, Slide} from "vue-carousel";

// LAYOUT COMPONENTS
import Card from "@/components/shared/Card";
import Item from "@/components/shared/Item";
import BreadCrumb from "@/components/shared/BreadCrumb";
import BotoesRotas from "@/components/shared/BotoesRotas";
import NaoEncontrado from "@/components/shared/NaoEncontrado";
import HeaderDisputa from "@/components/shared/HeaderDisputa";
import MensagemBox from "@/components/shared/MensagemBox";
import MensagemBoxLeilao from "@/components/shared/MensagemBoxLeilao";
import Filtro from "@/components/shared/Filtro";
import SeguirLeiloeiro from "@/components/shared/SeguirLeiloeiro";
import Lista from "./shared/Lista.vue";
import Loading from "./shared/Loading.vue";
import ModalHAbilitacaoExtra from "./shared/ModalHAbilitacaoExtra.vue";
import CondicoesVenda from "./shared/CondicoesVenda.vue";
import ModalAlertas from "./shared/ModalAlertas.vue";
import VideoTransmissao from "./shared/social/VideoTransmissao.vue";
import ModalPoupSalaDeDisputa from "@/components/shared/modalPoupSalaDeDisputa.vue";

let interval = null;

export default {
  name: "SalaDisputa",
  props: ['dadosLeilao', 'dadosModeradorId'],
  components: {
    ModalPoupSalaDeDisputa,
    VideoTransmissao,
    ModalAlertas,
    CondicoesVenda,
    ModalHAbilitacaoExtra,
    Loading,
    Lista,
    BreadCrumb,
    Card,
    Item,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    BotoesRotas,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao,
    SeguirLeiloeiro,
    //detect,
    Filtro
  },
  data() {
    return {
      dadosPopup: [],
      modalaviso_trt: true,
      visualizacao: 'card',
      lotesVisiveis: 40,
      lotesStep: 40,
      currentPage: 1,
      countLances: [],
      leilaoId: this.$route.params.id,
      lote_id_pregao: null,
      leilao: {},
      leilaoSemFirebase: [],
      lotes: [],
      visitas: [],
      lotesAcompanhar: [],
      lotesPregao: [],
      config_leiloeiro: [],
      dados_condicao: [],
      dadosCondicao: [],
      usuario: [],
      paginator: {pageCount: 1, countLote: 0},
      filtros: [],
      errors: [],
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: [],
      loteStatusReference: null,
      loteLanceReference: null,
      loteIncrementoReference: null,
      loteDtfechamentoReference: null,
      dadosRequisicao: {isLogado: false},
      value_video: null,
      loadingPage: true,
      loadingRefresh: false,
      naoEncomtrado: false,
      firstLoadSalaDisputa: true,
      paginaAtual: 0,
      seguir: false,
      message: "",
      liberado: false,
      fechamento: false,
      message_informativo: "",
      informativo: false,
      parametrosFiltro: "",
      refreshSalaDisputa: null,
      refreshCountSalaDisputa: 30000,
      cookie: true,
      saladisputa: null,
      lote_em_pregao: 1,
      loadfiltro: false,
      statusleilao_id: "",
      paramsite_proposta: [],
      intermediarios: null,
      abreModal: false,
      info: '',
      mostrarMesagem: false,
      statusModerador: null,
      is_favorito: false,
      destaqueLoteId: null,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.lotes.length / this.lotesStep);
    },
    visualizaLotes() {
      const start = (this.currentPage - 1) * this.lotesStep;
      const end = start + this.lotesStep;
      return this.lotes.slice(start, end);
    },
    isMobile() {
      return this.screenWidth <= 435;
    },
    paginatedPages() {
      if (!this.isMobile) {
        return Array.from({length: this.totalPages}, (_, i) => i + 1);
      }

      let start = Math.max(this.currentPage - 2, 1);
      let end = Math.min(start + 4, this.totalPages);
      if (end - start < 4) {
        start = Math.max(end - 4, 1);
      }

      return Array.from({length: end - start + 1}, (_, i) => start + i);
    },
  },
  watch: {
    '$route'(to, from) {
      this.resetCurrentPageIfRoot();
    },
    'dadosLeilao'(novo, ant) {
      this.leilaoSemFirebase = this.dadosLeilao
      this.callData()
    },
    'dadosModeradorId'(novo, ant) {
      this.statusModerador = this.dadosModeradorId
      this.lote_id_pregao = novo.items[0].statuslotemoderador_id
      if (this.seguir) {
        this.actionSeguir()
      }
    }
  },
  methods: {
    getDadosPopup() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      let self = this;

      fetch(`${hostName}/core/api/get-dados-site-popup`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          res.popups.filter((popup) => {
            if (!popup.bn_mostrar_em && popup.leilao_id === parseInt(self.leilaoId))
              self.dadosPopup = popup;
          })
        });
    },
    fecharPopup(dados) {
      this.modalaviso_trt = dados;
    },
    formataYoutubeLink(link) {
      if (link) {
        return `https://www.youtube.com/watch?v=${link}`;
      }
      return '';
    },
    resetCurrentPageIfRoot() {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has("page")) {
        this.currentPage = 1;
        sessionStorage.removeItem('currentPage');
      }
    },
    salvarLoteId(loteId) {
      const loteData = {
        id: loteId,
        timestamp: new Date().getTime()
      };
      sessionStorage.setItem('loteIdClicado', JSON.stringify(loteData));
    },
    destacarLote() {
      const loteData = JSON.parse(sessionStorage.getItem('loteIdClicado'));

      if (loteData) {
        const {id: loteId, timestamp} = loteData;
        this.destaqueLoteId = parseInt(loteId, 10);

        if (this.visualizaLotes.some(lote => lote.lote_id === loteId)) {
          this.scrollParaLote(loteId);
        } else {
          const loteIndex = this.lotes.findIndex(lote => lote.lote_id === loteId);
          const targetPage = Math.ceil((loteIndex + 1) / this.lotesStep);

          this.trocarPagina(targetPage, false);

          this.$nextTick(() => {
            let attempts = 0;
            const maxAttempts = 20;
            const interval = setInterval(() => {
              const loteElement = document.getElementById(`lote-${loteId}`);
              if (loteElement) {
                loteElement.scrollIntoView({behavior: 'smooth', block: 'center'});
                clearInterval(interval);
              } else if (attempts >= maxAttempts) {
                clearInterval(interval);
              }
              attempts++;
            }, 200);
          });
        }

        setTimeout(() => {
          sessionStorage.removeItem('loteIdClicado');
          this.destaqueLoteId = null;
        }, 6000);
      } else {
      }
    },
    scrollParaLote(loteId) {
      this.$nextTick(() => {
        const loteElement = document.getElementById(`lote-${loteId}`);
        if (loteElement) {
          loteElement.scrollIntoView({behavior: 'smooth', block: 'center'});
        } else {
        }
      });
    },
    trocarPagina(page, updateUrl = true) {
      if (page < 1 || page > this.totalPages || this.loadingPage) return;

      this.loadingPage = true;
      this.currentPage = page;

      sessionStorage.setItem('currentPage', this.currentPage);

      if (updateUrl) {
        const url = new URL(window.location);
        url.searchParams.set("page", this.currentPage);
        history.pushState({page: this.currentPage}, "", url);
      }

      this.callData();

      setTimeout(() => {
        this.loadingPage = false;

        this.$nextTick(() => {
          const lotesContainer = document.getElementById("scroll-here");
          if (lotesContainer) {
            lotesContainer.scrollIntoView({behavior: "smooth"});
          }
        });
      }, 500);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    handlePopState(event) {
      if (event.state && event.state.page) {
        this.currentPage = event.state.page;
        this.trocarPagina(this.currentPage, false);
      }
    },
    initPageFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const pageParam = urlParams.get("page");
      const storedPage = sessionStorage.getItem('currentPage');

      const filtrosExistem = this.parametrosFiltro && this.parametrosFiltro.length > 0;

      if (pageParam) {
        this.trocarPagina(parseInt(pageParam), false);
      } else if (storedPage) {
        this.trocarPagina(parseInt(storedPage), false);
      } else if (!filtrosExistem) {
        this.trocarPagina(1, false);
      }
    },
    clickEvent(e) {
      const _menus = e.target.closest('.menu');
      const _filters = e.target.closest('.filter');

      if (!_menus && !_filters) {
        $('.menu').addClass('tw-hidden');

        if (this.$refs.filters && this.$refs.filters.collapse) {
          this.$refs.filters.collapse.tipo = false;
          this.$refs.filters.collapse.categoria = false;
          this.$refs.filters.collapse.estado = false;
          this.$refs.filters.collapse.cidade = false;
        }
      }
    },
    openModalCondicoes() {
      this.$refs.modalCondicoes.modalToggle()
    },
    modalHabilitacao(descricao) {
      this.info = descricao
      this.$refs.modalHabilitacao.modalToggle()
    },
    setVisualizacao(tipo) {
      this.visualizacao = tipo
    },
    actionSeguir() {
      // AÇÃO DE SEGUIR LEILOEIRO
      if (this.seguir) {
        // ordena seguindo lote em pregao
        this.saladisputa.ordenaLotesPorSeq(this.lotes);
        this.saladisputa.carregaLoteEmPregao(
          this.lote_id_pregao,
          this.leilaoId
        );
      } else {
        this.saladisputa.ordenaLotesPorSeq(this.lotes);
        //this.saladisputa.carregaLoteEmPregao(this.lote_id_pregao, this.leilaoId)
      }
    },

    seguirLeiloeiro(ev) {
      this.seguir = !this.seguir;
      if (this.leilao && !this.leilao.bn_fechamentoautomatico) {
        if (this.seguir || this.statusModerador > 0) {
          this.lote_id_pregao = (this.statusModerador > 0)
            ? this.statusModerador : this.lotes[0].lote_id;
          this.actionSeguir();
        }
      }
    },

    callData() {
      this.loadingPage = true;
      this.loadingRefresh = true;
      this.paginaAtual = this.currentPage;
      this.saladisputa.refreshLotesListagem();
      this.saladisputa.calculaQtdePaginas();
      this.loadingPage = false;
      this.loadingRefresh = false;
      this.firstLoadSalaDisputa = false;
    },

    clickCallback(pageNum) {
      this.$router.push({query: {page: pageNum}});
      this.paginaAtual = pageNum;
      this.saladisputa.refreshLotesListagem();
      this.$forceUpdate();
      // this.$refs.paginate1.selected = this.$refs.paginate2.selected = pageNum - 1;
      this.$refs.ancora.scrollIntoView({behavior: "smooth"});
    },

    refreshPage(ev) {
      // REFRESH
      this.loadingRefresh = true;
      this.callData();
    },

    refreshFirebase() {
    },

    refreshDadosGerais(isFavorito = null) {
      console.log('status de favorito:', isFavorito);

      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;

      // usuario (favorito)
      fetch(`${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          self.usuario = res.usuario;
          self.visitas = res.visitas;

          self.dadosRequisicao.isLogado = self.usuario.id !== null ? true : false;
          self.saladisputa.configuraFavoritos();
          self.saladisputa.configuraVisitas();
        })
        .catch((error) => {
          console.log('Erro ao atualizar dados gerais:', error);
        })
    },

    getWindowWidth() {
      return window.innerWidth;
    },

    getIntermediarios() {
      //this.usuario.id = 25;
      if (this.usuario.id !== undefined) {
        const self = this;
        var db = this.firebase_db;
        db.ref(`/intermediarios/${self.usuario.id}`).on("value", function (
          usuario_intermediario
        ) {
          self.intermediarios = usuario_intermediario.val();
        });
      }
    },
  },
  created() {
    this.getDadosPopup();
    this.$vs.loading({background: "#fff", color: "#67302B"});

    //dados vindo do props
    this.leilaoSemFirebase = this.dadosLeilao
    this.statusModerador = this.dadosModeradorId

    clearInterval(window.INTERVALO_BUSCA);
    clearInterval(window.INTERVALO_CATEGORIA);

    this.saladisputa = new window.saladisputa(this);
    this.saladisputa.registraLotePregao();
    this.callData();

    // RECEBE INFORMAÇÕES DO COMPONENT shared/Filtro.vue    por meio de $on <= $emit
    this.$on("filtroChange", function (dadosFiltro) {
      let parametros = "";
      if (dadosFiltro.filtro1 !== "") {
        parametros += `segmento_id=${dadosFiltro.filtro1}`;
      } else {
        parametros = "";
      }

      if (dadosFiltro.filtro2 !== "") {
        parametros += `&filtro1=${dadosFiltro.filtro2}`;
      }
      if (dadosFiltro.filtro3 !== "") {
        parametros += `&filtro2=${dadosFiltro.filtro3}`;
      }
      if (dadosFiltro.filtro4 !== "") {
        parametros += `&filtro3=${dadosFiltro.filtro4}`;
      }
      if (dadosFiltro.filtro5 !== "") {
        parametros += `&filtro4=${dadosFiltro.filtro5}`;
      }
      this.parametrosFiltro = parametros;

      //filtro
      this.saladisputa.filtrarAction();
    });

    this.$on("dados-gerais", function (data) {
      this.config_leiloeiro = data.config_leiloeiro;
      this.dados_condicao = data.dados_condicao;
      this.usuario = data.usuario;
      this.dadosRequisicao.leilaoId = this.leilaoSemFirebase.id;
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false;
      this.visitas = data.visitas;
      this.saladisputa.configuraFavoritos();
      this.saladisputa.configuraVisitas();

      this.getIntermediarios();

      this.$vs.loading.close();
      this.loadfiltro = true;
    });

    this.$on("favoritoModificado", function (isFavorito) {
      this.is_favorito = isFavorito;
      this.refreshDadosGerais(isFavorito);
    });

    this.$on("loteIdAtualChange", function (id) {
      this.dadosRequisicao.loteId = id !== null ? id : this.lotes[0].lote_id;
      sessionStorage.setItem("loteId", id);
    });

    this.$on("liberacaoMensagem", function (json) {
      this.message = json.message;
      this.liberado = json.liberado;
      this.fechamento = json.fechamento; // leilaoSemFirebase.bn_fechamentoautomatico
      this.message_informativo = json.message_informativo;
      this.informativo = json.informativo;
      this.mostrarMesagem = json.mostrarMesagem
    });

    this.cookie = this.$root.cookieAtivo;
    this.$root.MensagemBrowserCookie();

    const self = this;
    var db = this.firebase_db;

    //Nó paramsite do firebase
    db.ref(`/paramsite/`).once("value", function (data) {
      $.each(data.val(), function (key, value) {
        //Alteração de label de venda direta para proposta
        if (value && value.statusparamsite_id == 74) {
          self.paramsite_proposta = value;
        }
      });
    });

    const pageFromStorage = sessionStorage.getItem('currentPage');
    const pageFromUrl = new URLSearchParams(window.location.search).get("page");
    const filtrosExistem = this.parametrosFiltro && this.parametrosFiltro.length > 0;

    this.currentPage = pageFromUrl
      ? parseInt(pageFromUrl)
      : pageFromStorage
        ? parseInt(pageFromStorage)
        : (filtrosExistem ? 1 : 1);

    window.addEventListener("popstate", this.handlePopState);
  },
  mounted() {
    this.resetCurrentPageIfRoot();
    this.initPageFromUrl();
    this.destacarLote();
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopState);
    window.removeEventListener("resize", this.updateScreenWidth);
  }
}
</script>

<style>
/* EFEITO DE TRANSIÇÃO*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ESTILOS GERAIS */
.refresh-btn {
  cursor: pointer;
  float: right;
  margin-right: 0;
  line-height: 28px;
  font-size: 20px;
  color: #67302b;
}

.open-listagem {
  float: right;
  margin-right: 7px;
  line-height: 31px;
  font-size: 20px;
  color: #67302b;
}

.doc-icons {
  cursor: pointer;
  text-align: center;
}

.dialog-content {
  max-height: 400px;
  overflow: auto;
}

.boxRegulamento {
  padding: 0px !important;
}

.container-box {
  height: auto !important;
  width: 100% !important;
  overflow: inherit !important;
}

#portotemplate .spinner {
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 200px;
}

#portotemplate .spinner div {
  background-color: #67302b !important;
}

#portotemplate a:hover,
#portotemplate a:focus {
  text-decoration: none;
}

.VueCarousel-navigation a.VueCarousel-navigation-prev {
  left: 24px !important;
  background: #fff;
  border-radius: 2px;
}

.VueCarousel-navigation a.VueCarousel-navigation-next {
  right: 24px !important;
  border-radius: 2px;
  background: #fff;
}

.VueCarousel-navigation a.VueCarousel-navigation--disabled {
  display: none;
}

.pag-container-vu {
  width: 98%;
  margin: 20px auto;
  text-align: center;
}

#portotemplate .pagination > li:first-child > a,
#portotemplate .pagination > li:last-child > a,
#portotemplate .pagination > li:last-child > span {
  padding: 2px 5px;
}

#portotemplate .li-hidden {
  display: none;
}

.open-listagem .router-link-active {
  color: #46a04c !important;
}

@media (max-width: 600px) {
  .pagination {
    margin-top: 60px !important;
    margin-bottom: -8px !important;
  }
}

@media (max-width: 500px) {
  #switch_seguir {
    margin-top: -5px;
  }

  .paginatio-mobile {
    margin-top: 17px;
  }
}

.texto-apregoamento {
  color: #444249;
  font-weight: bold;
  display: flex;
  font-size: 1.1em;
  justify-content: center;
  flex-direction: row-reverse;
  border-bottom: 3px solid #0a1a3d;
  position: relative;
  width: 565px;
  right: -55%;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  padding: 5px;
  border-radius: 3px;
}

.transmissao-refresh-dados {
  display: flex;
  position: relative;
  justify-content: flex-end;
}

.componente-lote-li {
  width: 270px;
}

@media (max-width: 1199px) {
  .texto-apregoamento {
    width: 467px;
    font-size: 1.23em;
  }
}

@media (max-width: 991px) {
  .texto-apregoamento {
    width: 358px;
    font-size: 12px;
  }
}

@media (max-width: 435px) {
  .transmissao-refresh-dados {
    display: none;
  }

  .texto-apregoamento {
    width: 381px;
    right: 0 !important;
    top: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SalaDisputa.vue